import React from 'react'
import { Box } from 'rebass'
import TextWidget from '../src/widgets/text'
import HeadingWidget from '../src/widgets/heading'
import ModelBannerWidget from '../src/widgets/model-banner'
import RangeCarouselWidget from '../src/widgets/range-carousel'
import MakeHeroWidget from '../src/widgets/make-hero'
import HeroWidget from '../src/widgets/hero'
import FullRangeWidget from '../src/widgets/full-range'
import RecentlyViewedVehiclesWidget from '../src/widgets/recently-viewed-vehicles'
import SearchHeroWidget from '../src/widgets/search-hero'
import SectionPromoWidget from '../src/widgets/section-promo'
import SellYourCarWidget from '../src/widgets/sell-your-car'
import NewsletterSignUpWidget from '../src/widgets/newsletter-signup'
import VehicleCarouselWidget from '../src/widgets/vehicle-carousel'
import HtmlWidget from '../src/widgets/html'
import ImageWidget from '../src/widgets/image'
import VideoWidget from '../src/widgets/video'
import FaqSelectorWidget from '../src/widgets/faq-selector'
import LatestArticlesWidget from '../src/widgets/latest-articles'
import SignpostWidget from '../src/widgets/signpost'
import OfferGrid from '../src/widgets/offer-grid'
import ContactWidget from '../src/widgets/contact'
import PromoCarouselWidget from '../src/widgets/promo-carousel'
import EventHypeStrip from '../src/widgets/event-hype-strip'
import SummaryReviews from '../src/widgets/summary-reviews'
import ReviewsWidget from '../src/widgets/reviews'
import UsedVehicleCarousel from '../src/widgets/used-vehicle-carousel'
import SubNavigation from '../src/widgets/sub-navigation'
import RangeByBodyType from '../src/widgets/range-by-body-type'
import ReviewsCarousel from '../src/widgets/reviews-carousel'
import CaseStudy from '../src/widgets/case-study'
import BodyshopForm from '../src/widgets/bodyshop-form'
import NewsStrip from '../src/widgets/news-strip'
import CareersForm from '../src/widgets/careers-form'
import FloatyPromo from '../src/widgets/floaty-promo'
import Headshot from '../src/widgets/headshot'
import AllDealerships from '../src/widgets/all-dealerships'
import HeroCarousel from '../src/widgets/hero-carousel'
import FeatureCarousel from '../src/widgets/feature-carousel'
import PrimaryActions from '../src/widgets/primary-actions'
import Pixel from '../src/widgets/fb-pixel'
import OfferDetailsTable from '../src/widgets/offer-details-table'
import ButtonGroup from '../src/widgets/button-group'
import CareersList from '../src/widgets/careers-list'
import ImageButtonGroup from '../src/widgets/image-button-group'
import CareersPage from '../src/widgets/careers-page'
import HomepageHero from '../src/widgets/homepage-hero'
import AutomotiveCardsWidget from '../src/widgets/automotive-cards'
import VehicleFinanceExample from '../src/widgets/vehicle-finance-example'
import UnmissableSpecialOffers from '../src/widgets/unmissable-special-offers'
import CookieList from '../src/widgets/cookie-list'
import ComplaintWidget from '../src/widgets/complaint'
import OfferCarousel from '../src/widgets/offer-carousel'

const Missing = (widget) => <p>MISSING WIDGET: {widget.type}</p>

const widgetList = {
  text: TextWidget,
  heading: HeadingWidget,
  automotiveCards: AutomotiveCardsWidget,
  modelBanner: ModelBannerWidget,
  rangeCarousel: RangeCarouselWidget,
  makeHero: MakeHeroWidget,
  hero: HeroWidget,
  fullRange: FullRangeWidget,
  recentlyViewedVehicles: RecentlyViewedVehiclesWidget,
  newsletterSignUp: NewsletterSignUpWidget,
  searchHero: SearchHeroWidget,
  sectionPromo: SectionPromoWidget,
  sellYourCar: SellYourCarWidget,
  vehicleCarousel: VehicleCarouselWidget,
  html: HtmlWidget,
  video: VideoWidget,
  faqSelector: FaqSelectorWidget,
  image: ImageWidget,
  latestArticles: LatestArticlesWidget,
  signpost: SignpostWidget,
  offerGrid: OfferGrid,
  contact: ContactWidget,
  promoCarousel: PromoCarouselWidget,
  reviews: ReviewsWidget,
  allReviews: ReviewsWidget,
  summaryReviews: SummaryReviews,
  eventHypeStrip: EventHypeStrip,
  dealGrid: OfferGrid,
  usedVehicleCarousel: UsedVehicleCarousel,
  subNavigation: SubNavigation,
  rangeByBodyType: RangeByBodyType,
  reviewsCarousel: ReviewsCarousel,
  faqTags: FaqSelectorWidget,
  caseStudy: CaseStudy,
  bodyshopForm: BodyshopForm,
  newsStrip: NewsStrip,
  careersForm: CareersForm,
  floatyPromo: FloatyPromo,
  headshot: Headshot,
  allDealerships: AllDealerships,
  heroCarousel: HeroCarousel,
  featureCarousel: FeatureCarousel,
  primaryActions: PrimaryActions,
  fbPixel: Pixel,
  offerDetailsTable: OfferDetailsTable,
  buttonGroup: ButtonGroup,
  careersList: CareersList,
  imageButtonGroup: ImageButtonGroup,
  careersPage: CareersPage,
  homepageHero: HomepageHero,
  vehicleFinanceExample: VehicleFinanceExample,
  unmissableSpecialOffers: UnmissableSpecialOffers,
  cookieList: CookieList,
  complaint: ComplaintWidget,
  offerCarousel: OfferCarousel
}

const widgetFactory = (widget) => {
  return widgetList[widget.type] || Missing
}

const WidgetArea = ({
  widgets,
  usedVehicles,
  makes,
  allModels,
  allBodyTypes,
  latestArticles,
  locations,
  container = Box,
  pageType = ''
}) => {
  if (!widgets) return null
  return widgets.map((widget, i) => {
    const Widget = widgetFactory(widget)
    return (
      <>
        {widget.anchorLink && <div id={widget.anchorLink} />}
        <Widget
          key={`widget-${widget.type}-${i}`}
          container={container}
          usedVehicles={usedVehicles}
          latestArticles={latestArticles}
          locations={locations}
          pageType={pageType}
          makes={makes}
          allModels={allModels}
          allBodyTypes={allBodyTypes}
          {...widget}
        />
      </>
    )
  })
}

export default WidgetArea
